import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'aphrodite'
import createStyles, { fontWeights, fontSizes } from './styles'

export class Text extends React.PureComponent {
  render() {
    const styles = getStyles(this.props, this.context)
    const Element = this.props.inline ? 'span' : 'div'

    return (
      <Element className={css(styles.root, this.props.style)}>
        {this.props.children}
      </Element>
    )
  }
}

Text.contextTypes = {
  theme: PropTypes.object,
}

Text.propsTypes = {
  center: PropTypes.bool,
  size: PropTypes.oneOf(Object.keys(fontSizes)),
  weight: PropTypes.oneOf(Object.keys(fontWeights)),
  inline: PropTypes.bool,
}

const getStyles = createStyles(
  (
    {
      color = 'text',
      center,
      size = 'medium',
      style,
      uppercase,
      weight = 'normal',
    },
    context,
    theme
  ) => ({
    root: {
      color: theme.colors[color],
      fontSize: fontSizes[size],
      fontWeight: fontWeights[weight],
      lineHeight: fontSizes[size] * 1.5 + 'px',
      textAlign: center ? 'center' : undefined,
      textTransform: uppercase ? 'uppercase' : undefined,
      ...style,
    },
  })
)



// WEBPACK FOOTER //
// ./src/components/Text.js